"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcomeActionProperties = exports.OutcomeActionType = exports.OutcomeTypesWithActions = exports.OutcomeGraphTypes = exports.OutcomeType = void 0;
var OutcomeType;
(function (OutcomeType) {
    OutcomeType["Success"] = "Success";
    OutcomeType["Failure"] = "Failure";
    OutcomeType["Variable"] = "Variable";
})(OutcomeType || (exports.OutcomeType = OutcomeType = {}));
exports.OutcomeGraphTypes = [OutcomeType.Success, OutcomeType.Failure];
exports.OutcomeTypesWithActions = [OutcomeType.Variable];
var OutcomeActionType;
(function (OutcomeActionType) {
    OutcomeActionType["Set"] = "Set";
    OutcomeActionType["Unset"] = "Unset";
    OutcomeActionType["Clear"] = "Clear";
})(OutcomeActionType || (exports.OutcomeActionType = OutcomeActionType = {}));
var OutcomeActionProperties;
(function (OutcomeActionProperties) {
    OutcomeActionProperties["Id"] = "id";
    OutcomeActionProperties["Value"] = "value";
})(OutcomeActionProperties || (exports.OutcomeActionProperties = OutcomeActionProperties = {}));
